import type { AuthApi } from './types'

import { swaggerAuthClient } from '#/api/swagger-auth'
import { getAllCodes } from '#/utils'

import { defineApi } from '../../define-api'

export const authApi = defineApi('/base', ({ prefix }) => {
  async function login(
    params: AuthApi.LoginParams,
  ): Promise<AuthApi.LoginResult> {
    return swaggerAuthClient.post(prefix('login'), params).then((res) => {
      return {
        accessToken: res?.token || '',
      }
    })
  }

  async function refreshToken() {
    return {} as any
  }

  async function logout() {
    return {} as any
  }

  async function getAccessCodes() {
    return swaggerAuthClient.post('/menu/getMenu').then((res: any) => {
      const obj = res?.menus?.find(
        (item: any) => item.name === import.meta.env.VITE_APP_TITLE,
      )
      // 获取所有的 authCode
      const authCodes = getAllCodes(obj, 'authCode')

      // 获取并过滤路径
      const appTitle = String(import.meta.env.VITE_APP_TITLE).toLowerCase()
      const paths = [
        ...getAllCodes(obj, 'path').filter(
          (path) => path && !path.includes(appTitle),
        ),
        '/workspace',
      ]
      // console.log(authCodes, paths, 'authCodes, paths')

      return {
        authCodes,
        paths,
      }
    })
  }

  return {
    login,
    refreshToken,
    logout,
    getAccessCodes,
  }
})
